// Table:
export const tableRegex = /<table>[\s\S]*?<\/table>/g;
export const tableTagsRegex = /<\/?(table|tr|td)>/g;
// Table Row:
export const trRegex = /<tr>(.*?)<\/tr>/gs;
// Table Cell:
export const tdRegex = /<td>(.*?)<\/td>/gs;
export const tdTags = /<\/?td>/g;
